import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

const useDeleteAccount = () => {
  const mutationFn = async (email: string) => {
    const { error } = await supabaseClient.functions.invoke('delete_account', {
      body: { email },
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }
  };

  return useMutation({
    mutationFn,
  });
};

export default useDeleteAccount;

